import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MCPlanningMaterialService } from '../../Services/MCPlanningMaterial/MCPlanningMaterial.service';
import { MatSnackBarComponent } from "../mat-snack-bar/mat-snack-bar.component";
import { FinalRequirementDetails, FinalRequirementFilters, ApprovedQuantity, RequirementType } from 'src/app/Models/MCPlanningMaterial/mcplanningmaterial';
import { PagerService } from 'src/app/Services/pager.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Router } from '@angular/router';
import { DefaultGlobalConfig } from 'ngx-toastr';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { Details } from 'src/app/Models/WHStockIn/whstockin';
//import internal = require('assert');

@Component({
  selector: 'app-final-requirement',
  templateUrl: './final-requirement.component.html',
  styleUrls: ['./final-requirement.component.css'],
  providers: [DatePipe]
})
export class FinalRequirementComponent implements OnInit {
  totalItemCount: any; 
  pageNo: number = 1;  
  totalPages:number;
  userID: string;
  roleID: string;
  selectedJobNumber: any;
  selectedJobNumberString: any;
  fileNameParts: string[];
  color : any;
  statusColor : any =  '#000';
  selectedRMHName: any;
  selectedRMHNameString: any;
  selectedJobType: any;
  selectedJobTypeString: any;
  selectedBrand: any;
  selectedBrandString: any;
  @ViewChild('file') input;
  @ViewChild('year') year;
  selectedCrop: any;
  selectedCropString: any;
  selectedLanguage: any;
  selectedLanguageString: any;
  selectedStatus: any;
  selectedStatusString: any;
  selectedRequirementType: any;
  selectedRequirementTypeString: any;
  selectedMA: any;
  selectedMAString: any;
  selectedMonth: any;
  selectedMonthString: any;
  selectedYear: any;
  finalReqFilters: FinalRequirementFilters = new FinalRequirementFilters();
  requirementdetails: FinalRequirementDetails[] = [];
  mainReqDetail: FinalRequirementDetails[] = [];
  loader: string = 'none';
  files: File[] = [];
  fileName: string = '';
  pageSetting: number = 10;
  pager: any = {};
  //model: FinalRequirementDetails[] = [];
  modalSetting: number = 0;
  modelFilter: any[];
  modelDepandent: any[];
  selectedPaging: any;
  selectedState: any;
  selectedStateString: any;
  selectedBM: any;
  selectedBMString: any;
  userName: string;
  fileType: string;
  date = new Date();
  bgColor: string = 'white';
  selected: number = 0;
  customActive: boolean = true;
  sortDirection: string = '';
  ascNumberSort: boolean = true;
  dropdownList = [
    { item_id: '1', item_text: 'Jan' },
    { item_id: '2', item_text: 'Feb' },
    { item_id: '3', item_text: 'Mar' },
    { item_id: '4', item_text: 'Apr' },
    { item_id: '5', item_text: 'May' },
    { item_id: '6', item_text: 'Jun' },
    { item_id: '7', item_text: 'Jul' },
    { item_id: '8', item_text: 'Aug' },
    { item_id: '9', item_text: 'Sep' },
    { item_id: '10', item_text: 'Oct' },
    { item_id: '11', item_text: 'Nov' },
    { item_id: '12', item_text: 'Dec' }
  ];
  dropdownSettings1: IDropdownSettings = {
    singleSelection: false,
    idField: 'rMHCode',
    textField: 'rMHName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings2: IDropdownSettings = {
    singleSelection: false,
    idField: 'brandID',
    textField: 'brandName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings3: IDropdownSettings = {
    singleSelection: false,
    idField: 'cropID',
    textField: 'cropName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings4: IDropdownSettings = {
    singleSelection: false,
    idField: 'jobTypeID',
    textField: 'jobTypeName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings5: IDropdownSettings = {
    singleSelection: false,
    idField: 'requirementTypeID',
    textField: 'requirementTypeName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings6: IDropdownSettings = {
    singleSelection: false,
    idField: 'languageID',
    textField: 'languageName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings7: IDropdownSettings = {
    singleSelection: false,
    idField: 'requirementStatusID',
    textField: 'requirementStatusName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings8: IDropdownSettings = {
    singleSelection: false,
    idField: 'stateID',
    textField: 'stateName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings9: IDropdownSettings = {
    singleSelection: false,
    idField: 'bmCode',
    textField: 'bmName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings10: IDropdownSettings = {
    singleSelection: false,
    idField: 'maCode',
    textField: 'maName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings11: IDropdownSettings = {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSettings12: IDropdownSettings = {
    singleSelection: true,
    idField: 'year',
    textField: 'year',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: false
  };


  constructor(private mcPlanningMaterialService: MCPlanningMaterialService, private snackBar: MatSnackBarComponent,
    private _pagerService: PagerService, private router: Router, private datepipe: DatePipe,private toastr: ToastrService) {
    this.roleID = localStorage.getItem('mcmt_roleID');
    this.userID = localStorage.getItem('mcmt_userId');
    this.userName = localStorage.getItem('mcmt_userName');
  }

 
  ngOnInit() {   
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    this.finalRequiremetFilters();
    this.selectedPaging = '0';
    if (this.roleID == '28') {
      this.selectedBM = this.userID;
    }
    this.finalRequirementDetails();
  }

   

  finalRequiremetFilters() {
    this.loader = 'block';
    let year=''
    if (typeof this.selectedYear !== 'undefined') {
      year = this.selectedYear
    }

    this.mcPlanningMaterialService.finalRequirementFilters(year)
      .subscribe((resData: any) => {
        if (resData.status == true) {
          this.finalReqFilters = resData.data;
          
          this.onCurrentRequirementYearSelected(this.finalReqFilters.year);
        }
        else {
          this.toastr.error(resData.msg);
          this.loader = 'none';
        }
      }
      );
  }

  public onCurrentRequirementYearSelected(item: any) {
    class YearItemList{
      id: number;
      text: string;
  }
    let requiredItem: YearItemList[] = [];
    var obj;
    if(this.roleID == "47" || this.roleID == "51")
    {
       obj = {
        id : (new Date()).getFullYear(),
        text: (new Date()).getFullYear().toString()
      }
    }
    else{

     obj = {
      id : item[0].currentrequirementYear,
      text: item[0].currentrequirementYear
    }
  }
    requiredItem.push(obj)
    this.year.selectedItems=requiredItem
    for (var i = 0; i < this.year.selectedItems.length; i++) {
      this.selectedYear =this.year.selectedItems[i].text;
    }
    this.dropdownSettings12 = {
      singleSelection: true,
      idField: 'year',
      textField: 'year',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: false,
      enableCheckAll: false
    };
  }

  finalRequirementDetails() {
    this.loader = 'block';
    
    this.mcPlanningMaterialService.finalRequirementDetails(this.pageNo,this.selectedJobNumberString, this.selectedRMHNameString, this.selectedJobTypeString, this.selectedBrandString, this.selectedCropString,
      this.selectedRequirementTypeString, this.selectedLanguageString, this.selectedStatusString, this.selectedBMString, this.selectedMAString, this.selectedMonthString, this.selectedStateString,this.selectedYear
)
      .subscribe((resdata: any) => {
        if (resdata.status == true) {
          this.mainReqDetail = resdata.data;
          this.requirementdetails = resdata.data;
          this.totalItemCount=resdata.data.length>0? resdata.data[0].totaldata:0;
          this.pageSetting=resdata.data.length>0? resdata.data[0].pageSize:10;
          //set pagination
          this.totalPages = Math.ceil(this.totalItemCount / this.pageSetting);  
          this.loader = 'none';
          
         
        }
        else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      })
  }
  showRecordsByPageNumber(page) {  
    if(page>this.totalPages || page<1){
      return;
    }
    this.pageNo = page;  
    this.finalRequirementDetails();
  }  

  excelDownload() {
    this.loader = 'block';
    let selectJobNo: any[] = this.selectedJobNumber;
    let selectRmh: any[] = this.selectedRMHName;
    let selectJob: any[] = this.selectedJobType;
    let selectBrand: any[] = this.selectedBrand;
    let selectCrop: any[] = this.selectedCrop;
    let selectType: any[] = this.selectedRequirementType;
    let selectLanguage: any[] = this.selectedLanguage;
    let selectStatus: any[] = this.selectedStatus;
    let selectBm: any[] = this.selectedBM;
    let selectMa: any[] = this.selectedMA;
    let selectMonth: any[] = this.selectedMonth;
    let selectState: any[] = this.selectedState;
    let selectYear: any[] = this.selectedYear;
    let customJobNo: string = "";
    let customRmh: string = "";
    let customJob: string = "";
    let customBrand: string = "";
    let customCrop: string = "";
    let customType: string = "";
    let customLanguage: string = "";
    let customStatus: string = "";
    let customBm: string = "";
    let customMa: string = "";
    let customMonth: string = "";
    let customState: string = "";
 
    if (selectJobNo != undefined) {
      selectJobNo.forEach(x => {
        if (x.length == 0) {
          customJobNo = "";
        }
        else {
          if (customJobNo == "") {
            customJobNo = x.jobNumberName;
          }
          else {
            customJobNo = customJobNo.concat(",");
            customJobNo = customJobNo.concat(x.jobNumberName);
          }
        }
      })
    }
    if (selectRmh != undefined) {
      selectRmh.forEach(x => {
        if (x.length == 0) {
          customRmh = "";
        }
        else {
          if (customRmh == "") {
            customRmh = x.rMHCode;
          }
          else {
            customRmh = customRmh.concat(",");
            customRmh = customRmh.concat(x.rMHCode);
          }
        }
      })
    }
    if (selectJob != undefined) {
      selectJob.forEach(x => {
        if (x.length == 0) {
          customJob = "";
        }
        else {
          if (customJob == "") {
            customJob = x.jobTypeName;
          }
          else {
            customJob = customJob.concat(",");
            customJob = customJob.concat(x.jobTypeName);
          }
        }
      })
    }
    if (selectBrand != undefined) {
      selectBrand.forEach(x => {
        if (x.length == 0) {
          customBrand = "";
        }
        else {
          if (customBrand == "") {
            customBrand = x.brandName;
          }
          else {
            customBrand = customBrand.concat(",");
            customBrand = customBrand.concat(x.brandName);
          }
        }
      })
    }
    if (selectCrop != undefined) {
      selectCrop.forEach(x => {
        if (x.length == 0) {
          customCrop = "";
        }
        else {
          if (customCrop == "") {
            customCrop = x.cropName;
          }
          else {
            customCrop = customCrop.concat(",");
            customCrop = customCrop.concat(x.cropName);
          }
        }
      })
    }
    if (selectType != undefined) {
      selectType.forEach(x => {
        if (x.length == 0) {
          customType = "";
        }
        else {
          if (customType == "") {
            customType = x.requirementTypeID;
          }
          else {
            customType = customType.concat(",");
            customType = customType.concat(x.requirementTypeID);
          }
        }
      })
    }
    if (selectLanguage != undefined) {
      selectLanguage.forEach(x => {
        if (x.length == 0) {
          customLanguage = "";
        }
        else {
          if (customLanguage == "") {
            customLanguage = x.languageName;
          }
          else {
            customLanguage = customLanguage.concat(",");
            customLanguage = customLanguage.concat(x.languageName);
          }
        }
      })
    }
    if (selectStatus != undefined) {
      selectStatus.forEach(x => {
        if (x.length == 0) {
          customStatus = "";
        }
        else {
          if (customStatus == "") {
            customStatus = x.requirementStatusID;
          }
          else {
            customStatus = customStatus.concat(",");
            customStatus = customStatus.concat(x.requirementStatusID);
          }
        }
      })
    }
    if (this.roleID != "28") {
      if (selectBm != undefined) {
        selectBm.forEach(x => {
          if (x.length == 0) {
            customBm = "";
          }
          else {
            if (customBm == "") {
              customBm = x.bmCode;
            }
            else {
              customBm = customBm.concat(",");
              customBm = customBm.concat(x.bmCode);
            }
          }
        })
      }
    }
    if (this.roleID != "28") {
      if (selectMa != undefined) {
        selectMa.forEach(x => {
          if (x.length == 0) {
            customMa = "";
          }
          else {
            if (customMa == "") {
              customMa = x.maName;
            }
            else {
              customMa = customMa.concat(",");
              customMa = customMa.concat(x.maName);
            }
          }
        })
      }
    }
    if (selectMonth != undefined) {
      selectMonth.forEach(x => {
        if (x.length == 0) {
          customMonth = "";
        }
        else {
          if (customMonth == "") {
            customMonth = x.item_id;
          }
          else {
            customMonth = customMonth.concat(",");
            customMonth = customMonth.concat(x.item_id);
          }
        }
      })
    }
    if (selectState != undefined) {
      selectState.forEach(x => {
        if (x.length == 0) {
          customState = "";
        }
        else {
          if (customState == "") {
            customState = x.stateName;
          }
          else {
            customState = customState.concat(",");
            customState = customState.concat(x.stateName);
          }
        }
      })
    }
    this.selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    this.mcPlanningMaterialService.downloadFinalRequirementExcel(customJobNo, customRmh, customJob, customBrand, customCrop, customType,
      customLanguage, customStatus, customBm, customMa, customMonth, customState,this.roleID,this.selectedYear)
      .subscribe(
        success => {
          var date = new Date();
          let latest_date = this.datepipe.transform(date, 'dd-MMM-yy')
          let name = localStorage.getItem('mcmt_userName').split(' ');
          let firstname = name[0];
          let lastName = name[1];
          let cYear = this.year.selectedItems[0].id;
          let excelName = firstname + '_' + lastName + '_'+ cYear + '_FinalRequirement_' + latest_date + '.xlsx';
          saveAs(success, excelName);

          this.loader = 'none';
        },
        err => {
          this.toastr.error("No Data Found.");
          this.loader = 'none';
        }
      );
  }

  approveReviewFinalRequirement() {
    this.loader = 'block';
    let approvedQuantity: ApprovedQuantity[] = [];
    let active: number = 0;
    let error: boolean = false;
    let requestedQty : any;
    let quantity:any;
    this.mainReqDetail.forEach(function (detail) {   
        if (detail.isActive == true) {
          let changed: boolean = false
          if (detail.isApprovedQuantityUpdated == 1) {
            changed = true;
          }
          else {
            changed = detail.approvedQuantity != detail.approvedQuantityCopy ? true : false;
          }
          var approvedQty = {
            RequirementDetailID: detail.jobNumber,
            Quantity: detail.approvedQuantity,
            IsChanged: changed,
            RequirementType: detail.requirementType
          };
          approvedQuantity.push(approvedQty)
          active = 1;
          if(detail.requestedQuantity.toString().includes(',')){
            requestedQty = detail.requestedQuantity.replaceAll(',', '');
          }
          else{
            requestedQty = detail.requestedQuantity;
          }
          if (detail.approvedQuantity > parseInt(requestedQty)) {
            error = true;
          } 
          quantity=detail.approvedQuantity;

    // else{
    //   this.toastr.error('Please enter approved quantity.');
    //   this.loader = 'none';
    // }
  }
    });
    if(quantity==null){
      this.toastr.error('Approved quantity cannot be blank.');
      this.loader = 'none';
    }
    else if(quantity<0){
      this.toastr.error('Approved quantity cannot be negative.');
      this.loader = 'none';
    }
    else{
    if (active == 1) {
      if (error == false) {
        this.mcPlanningMaterialService.approveReviewFinalRequirement(approvedQuantity)
          .subscribe((resdata: any) => {
            if (resdata.status == true) {
              if (resdata.data[0].status == 'true') {
                this.toastr.success(resdata.data[0].msg);
                this.selectedJobNumber = '';
                this.selectedRMHName = '';
                this.selectedJobType = '';
                this.selectedBrand = '';
                this.selectedCrop = '';
                this.selectedRequirementType = '';
                this.selectedLanguage = '';
                this.selectedStatus = '';
                if (this.roleID == '28') {
                  this.selectedBM = '';
                }
                this.selectedMA = '';
                this.selectedMonth = '';
                this.selectedState = '';
                this.selected = 0;
                this.finalRequirementDetails();
                this.filter();
                this.loader = 'none';
              }
              else {
                this.toastr.error(resdata.data[0].msg);
                this.loader = 'none';
              }
            }
            else {
              this.toastr.error('Some problem occurred, please try again later.');
              this.loader = 'none';
            }
          });
      }
      else{
        this.toastr.error('Approved Quantity cannot be more than Requested Quantity.');
        this.loader = 'none';
      }
    }
  
    else {
      this.toastr.error('Requirement not selected');
      this.loader = 'none';
    }
  }
  }

  filesAdd(files: File[]) {
    this.files = [];
    this.files = files;
    this.fileNameParts = files[0].name.split('.');
    this.fileType = files[0].name.split('.')[this.fileNameParts.length - 1];
    if (this.fileType != 'xls' && this.fileType != 'xlsx') {
      this.toastr.error('Please Select Valid File Type.');
      this.loader = 'none';
      this.input.nativeElement.value = null;
      return false;
    }
    this.loader = 'block';
    this.mcPlanningMaterialService.uploadApprovedQuantity(<File>this.files[0])
      .subscribe((resData: any) => {
        if (resData.status == true) {
          if (resData.data == 1) {
            this.toastr.error(resData.message);
            this.loader = 'none';
            this.input.nativeElement.value = null;
          }
          else{ 
            if (resData.data[0].status == 'true') {
              this.finalRequirementDetails();
              this.filter();
              this.toastr.success(resData.data[0].msg);
              this.loader = 'none';
              this.input.nativeElement.value = null;
            }
            else {
              this.toastr.error(resData.data[0].msg);
              this.loader = 'none';
              this.input.nativeElement.value = null;
            }           
          }
        }
        else {
          this.toastr.error('Some problem occurred, please try again later.');
          this.loader = 'none';
          this.input.nativeElement.value = null;
        }
        this.files = [];
        this.loader = 'none';
      });
    this.files = this.files;
    this.fileName = this.files[0].name;
  }

  selectAll() {
    if (this.selected == 0) {
      if (this.roleID == "47" || this.roleID == "51") {
        this.requirementdetails.forEach(function (detail) {
          if (detail.status == "Approval Pending By MC Team") {
            detail.isActive = true;
          }
        })
      }
      else {
        this.requirementdetails.forEach(function (detail) {
          if (detail.status == "Approval Pending By Brand Manager") {
            detail.isActive = true;
          }
        })
      }
    }
    if (this.selected == 1) {
      if (this.roleID == "47" || this.roleID == "51") {
        this.requirementdetails.forEach(function (detail) {
          if (detail.status == "Approval Pending By MC Team") {
            detail.isActive = false;
          }
        })

      }
      else {
        this.requirementdetails.forEach(function (detail) {
          if (detail.status == "Approval Pending By Brand Manager") {
            detail.isActive = false;
          }
        })
      }
    }
  }

  check(index: any) {
  
  
    this.bgColor = 'white';
      this.color = '#000';
    if (this.requirementdetails[index].status == "Approval Pending By Brand Manager") {
      if (this.requirementdetails[index].requestedQuantity.replace(',', '') > this.requirementdetails[index].approvedQuantity) {
        if (this.requirementdetails[index].isApprovedQuantityUpdated == 1) {
          this.bgColor = '#f50008';
          this.color = '#fff';
        }
      }
      else {
        this.bgColor = 'white';
        this.color = '#000';
      }
    }
    else if (this.requirementdetails[index].status != "Approval Pending By Brand Manager" 
      && this.requirementdetails[index].status != "Approval Pending By MC Team") {
      if (this.requirementdetails[index].isApprovedQuantityUpdated == 1) {
        this.bgColor = '#f50008';
        this.color = '#fff';
      }
      if(this.requirementdetails[index].requestedQuantity.replace(',', '') == this.requirementdetails[index].approvedQuantity && this.requirementdetails[index].approvedQuantity != 0) {
        this.bgColor = '#0a9020';
        this.color = '#fff';
      }
    }
    else {
      this.bgColor = 'white';
      this.color = '#000';
    }
    if (this.roleID == "47" || this.roleID=="51") {
      if (this.requirementdetails[index].status != "Approval Pending By MC Team") {
        return 'true'
      }
      else {
        return 'false'
      }
    }
    else if (this.roleID == "28"  || this.roleID=="51"){
      if (this.requirementdetails[index].status != "Approval Pending By Brand Manager") {
        return 'true'
      }
      else {
        return 'false'
      }
    }
    else{
      return 'true'
    }
  }

  updateIsactive(index: any) {
  
    let selectedIdCustom = this.requirementdetails[index].jobNumber;
    let isActiveCustom = this.requirementdetails[index].isActive;
    let requirementTypeCustom = this.requirementdetails[index].requirementType;
    let priceCustom = this.requirementdetails[index].unitPrice;
    this.mainReqDetail.forEach(function (detail) {
      if (detail.jobNumber == selectedIdCustom && detail.requirementType == requirementTypeCustom && detail.unitPrice == priceCustom) {
        detail.isActive = isActiveCustom;
      }
    })

  }

  saveApprovedQuantity(index: any) {
    let idCustom = this.requirementdetails[index].jobNumber;
    let requirementTypeCustom = this.requirementdetails[index].requirementType;
    let qtyCustom = this.requirementdetails[index].requestedQuantity;
    let approvedQtyCustom = this.requirementdetails[index].approvedQuantity;
    this.mainReqDetail.forEach(function (detail) {
      if (detail.requirementType == requirementTypeCustom && detail.jobNumber == idCustom && detail.requestedQuantity == qtyCustom) {
        detail.approvedQuantity = approvedQtyCustom;
      }
    })
  }

  filter() {
       
    this.selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    var bm='';
    if(this.roleID !='28' && this.roleID !='39')
    {
    if(this.selectedBM !=undefined)
    {
      for(var i=0;i<this.selectedBM.length;i++)
      {
        bm=bm+this.selectedBM[i].bmCode+",";
      }
      bm=bm.slice(0,-1); 
      this.selectedBMString=bm;
    }
  }
  
    var ma='';
    if(this.roleID =='47' || this.roleID =='48' || this.roleID =='51')
    {
    if(this.selectedMA !=undefined)
    {
      for(var i=0;i<this.selectedMA.length;i++)
      {
        ma=ma+this.selectedMA[i].maCode+",";
      }
      ma=ma.slice(0,-1); 
      this.selectedMAString=ma;
    }
  }
    var rmhname='';
    if(this.selectedRMHName != undefined)
    {
    for(var i=0;i<this.selectedRMHName.length;i++)
    {
rmhname=rmhname+this.selectedRMHName[i].rMHCode+",";
    }
    rmhname=rmhname.slice(0,-1); 
    this.selectedRMHNameString=rmhname;
  }
    var brandname='';
    if(this.selectedBrand != undefined)
    {
    for(var k=0;k<this.selectedBrand.length;k++)
    {

      brandname=brandname+this.selectedBrand[k].brandName+",";
    }
    brandname=brandname.slice(0,-1);
    this.selectedBrandString=brandname;
  }
    var cropnames='';
    if(this.selectedCrop !=undefined)
    {
    for(var z=0;z<this.selectedCrop.length;z++)
    {

      cropnames=cropnames+this.selectedCrop[z].cropID+",";
    }
    cropnames=cropnames.slice(0,-1)
    this.selectedCropString=cropnames;
  }
  var jobbtypename='';
  if(this.selectedJobType != undefined)
  {
    for(var z=0;z<this.selectedJobType.length;z++)
    {

      jobbtypename=jobbtypename+this.selectedJobType[z].jobTypeID+",";
    }
    jobbtypename=jobbtypename.slice(0,-1);
    this.selectedJobTypeString=jobbtypename;

  }
  var lid='';
  if(this.selectedLanguage != undefined)
  {

    for(var z=0;z<this.selectedLanguage.length;z++)
    {

      lid=lid+this.selectedLanguage[z].languageID+",";
    }
    lid=lid.slice(0,-1);
    this.selectedLanguageString=lid;
  }
  var monthid='';
  if(this.selectedMonth != undefined)
  {
    for(var z=0;z<this.selectedMonth.length;z++)
    {

      monthid=monthid+this.selectedMonth[z].item_id+",";
    }
    monthid=monthid.slice(0,-1);
    this.selectedMonthString=monthid;

  }
  var state='';
  if(this.selectedState != undefined)
  {
    for(var z=0;z<this.selectedState.length;z++)
    {

      state=state+this.selectedState[z].stateName+",";
    }
    state=state.slice(0,-1);
    this.selectedStateString=state;
  }
  var status='';
  if(this.selectedStatus != undefined)
  {
    for(var z=0;z<this.selectedStatus.length;z++)
    {

      status=status+this.selectedStatus[z].requirementStatusName+",";
    }
    status=status.slice(0,-1);
    this.selectedStatusString=status;

  }
  this.pageNo=1;  
  this.finalRequirementDetails();        
  }
  
  
  onItemSelectMA() {
    let customMa = this.selectedMA;
    let customRmh = [];
    let customState = [];
    let finalRmh = [];
    let finalState = [];
    let active: boolean = true;
    this.finalReqFilters.maMapping.forEach(detail => {
      customMa.forEach(element => {
        if (element.maName == detail.ma) {
          customRmh.push(detail.rMHCode);
          customState.push(detail.state);
        }
      });
    })
    this.finalReqFilters.rmhs.forEach(element => {
      customRmh.forEach(detail => {
        if (detail == element.rMHCode) {
          if (finalRmh.length == 0) {
            finalRmh.push(element);
          }
          else {
            finalRmh.forEach(x => {
              if (element.rMHCode == x.rMHCode) {
                active = false;
              }
            })
            if (active == true) {
              finalRmh.push(element);
            }
            active = true;
          }
        }
      })
    })
    this.finalReqFilters.states.forEach(element => {
      customState.forEach(detail => {
        if (detail == element.stateName) {
          if (finalState.length == 0) {
            finalState.push(element);
          }
          else {
            finalState.forEach(x => {
              if (x.stateName == element.stateName) {
                active = false
              }
            })
            if (active == true) {
              finalState.push(element);
            }
            active = true
          }
        }
      })
    })
    this.selectedState = finalState;
    this.selectedRMHName = finalRmh;
  }

  onItemSelectBM() {
    let customBm = this.selectedBM;
    let customBrand = [];
    let finalBrand = [];
    let active: boolean = true;
    this.finalReqFilters.bmMapping.forEach(element => {
      customBm.forEach(detail => {
        if (element.bmName == detail.bmName) {
          customBrand.push(element.brandName);
        }
      });
    })
    this.finalReqFilters.brands.forEach(y => {
      customBrand.forEach(element => {
        if (element == y.brandName) {
          if (finalBrand.length == 0) {
            finalBrand.push(y);
          }
          else {
            finalBrand.forEach(x => {
              if (x.brandName == y.brandName) {
                active = false;
              }
            })
            if (active == true) {
              finalBrand.push(y)
            }
            active = true
          }
        }
      })
    })
    this.selectedBrand = finalBrand;
  }
  
  onItemSelectState() {
    debugger;
    let customState: any[] = this.selectedState;
    let customRmh = [];
    let finalRMH = [];
    let customLanguage = [];
    let finalLanguage = [];
    let active: boolean = false;
    let check: boolean = true;
    this.finalReqFilters.maMapping.forEach(x => {
      customState.forEach(detail => {
        if (x.state == detail.stateName) {
          if (customRmh.length == 0) {
            customRmh.push(x);
          }
          else {
            customRmh.forEach(y => {
              if (y.state != x.state) {
                active = true;
              }
            })
            if (active == true) {
              customRmh.push(x);
              active = false;
            }
          }
        }
      })
    })
    this.finalReqFilters.rmhs.forEach(x => {
      customRmh.forEach(detail => {
        if (x.rMHCode == detail.rMHCode) {
          if (finalRMH.length == 0) {
            finalRMH.push(x);
          }
          else {
            finalRMH.forEach(y => {
              if (y.rMHCode == x.rMHCode) {
                check = false;
              }
            })
            if (check == true) {
              finalRMH.push(x);
            }
            check = true;
          }
        }
      })
    })
    this.finalReqFilters.mapping.forEach(x => {
      customState.forEach(detail => {
        if (x.state == detail.stateName) {
          if (customLanguage.length == 0) {
            customLanguage.push(x);
          }
          else {
            customLanguage.forEach(y => {
              if (y.state != x.state) {
                active = true;
              }
            })
            if (active == true) {
              customLanguage.push(x);
              active = false;
            }
          }
        }
      })
    })
    this.finalReqFilters.languages.forEach(x => {
      customLanguage.forEach(detail => {
        if (x.languageName == detail.languageName) {
          if (finalLanguage.length == 0) {
            finalLanguage.push(x);
          }
          else {
            finalLanguage.forEach(y => {
              if (y.languageName == x.languageName) {
                check = false;
              }
            })
            if (check == true) {
              finalLanguage.push(x);
            }
            check = true
          }
        }
      })
    })
    this.selectedRMHName = finalRMH;
    this.selectedLanguage = finalLanguage;
  }

  onStateDeSelect() {
    this.onItemSelectState()
  }

  onBmDeSelect() {
    this.onItemSelectBM()
  }

  onMaDeSelect() {
    this.onItemSelectMA();
  }

  sort() {
    let sortedArray: any[] = [];
    let splitString: any[] = [];
    if (this.ascNumberSort == true) {
      this.dropdownList.forEach(x => {
        this.requirementdetails.forEach(element => {
          splitString = element.requirementMonth.split("'");
          if (x.item_text == splitString[0]) {
            sortedArray.push(element);
          }
        })
      })
      this.ascNumberSort = false;
      this.sortDirection = 'asc';
      this.requirementdetails = sortedArray;
    }
    else {
      this.dropdownList.forEach(x => {
        this.requirementdetails.forEach(element => {
          splitString = element.requirementMonth.split("'");
          if (x.item_text == splitString[0]) {
            sortedArray.push(element);
          }
        })
      })
      this.ascNumberSort = true;
      this.sortDirection = 'desc';
      this.requirementdetails = sortedArray.reverse();
    }
  }

  ConvertToCurrency(value:any)
  {
    let parts = Intl.NumberFormat('en-IN');
    return parts.format(parseInt(value.replace(',','')));
  }
}
